<template>

    <div class="controls">

        <ButtonTemplate id="translate-button"
                        class="segment-control"
                        :disabled="false"
                        :tooltipMessage="translateTooltip"
                        @buttonClick="doTranslate">
            <span class="material-symbols-outlined">
                translate
            </span>
        </ButtonTemplate>

        <ButtonTemplate id="variants-button"
                        class="segment-control"
                        :disabled="!showTranslationVariants"
                        :tooltipMessage="togleVariantsTooltip"
                        @buttonClick="doToogleVariantsPopup">
            <span class="material-symbols-outlined">
                menu
            </span>
        </ButtonTemplate>

        <ButtonTemplate id="update-button"
                        class="segment-control"
                        :disabled="!showUpdate"
                        :tooltipMessage="updateTranslationTooltip"
                        @buttonClick="doUpdateTranslation">
            <span class="material-symbols-outlined">
                vertical_align_bottom
            </span>
        </ButtonTemplate>

        <ButtonTemplate id="save-button"
                        class="segment-control"
                        :disabled="!showSave"
                        :tooltipMessage="saveTranslationTooltip"
                        @buttonClick="doAddTranslation">
            <span class="material-symbols-outlined">
                add
            </span>
        </ButtonTemplate>

        <ButtonTemplate id="copy-button"
                        class="segment-control"
                        :disabled="copyDisabled"
                        :tooltipMessage="copyTooltip"
                        @buttonClick="doCopy">
            <span class="material-symbols-outlined">
                content_copy
            </span>
        </ButtonTemplate>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    
    import { shortcuts } from '@/utils/shortcuts';
    import { translationSegmentService } from './translationSegmentService'
    
    import { TranslationSegment } from '@/models/TranslationSegment';
    import { SegmentEditorItem } from '@/models/SegmentEditorItem';

    import ButtonTemplate from '@/components/ButtonTemplate.vue';

    export default defineComponent({
        props: {
            modelValue: Object,
        },
        components: {
            ButtonTemplate,
        },
        data() {
            return {
                translationSegmentService: translationSegmentService.getInstance(),
                translateTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.translate),
                saveTranslationTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.addTranslation),
                updateTranslationTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.updateTranslation),
                copyTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.copy),
                togleVariantsTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.variantsPopover),

            }
        },
        computed: {
            segmentItem: {
                get(): SegmentEditorItem { return this.modelValue as SegmentEditorItem; },
                set(value: SegmentEditorItem) { this.$emit('input', value); }
            },
            translationSegment: {
                get(): TranslationSegment { return this.segmentItem.data as TranslationSegment; },
                set(value: TranslationSegment) { this.segmentItem.data = value }
            },
            copyDisabled(): boolean {
                return this.translationSegment.translationVariants == null;
            },
            focused(): boolean {
                return this.segmentItem.focused;
            },
            showSave(): boolean {
                return this.focused &&
                    this.translationSegmentService.translationCouldBeAdded();
            },
            showUpdate(): boolean {
                return this.focused &&
                    this.translationSegmentService.translationCouldBeUpdated();
            },
            showTranslationVariants(): boolean {
                return this.translationSegment.translationVariants != null;
            }
        },
        methods: {
            doCopy() {
                this.translationSegmentService.copy(this.translationSegment.translationSegmentId);
            },
            doTranslate() {
                this.translationSegmentService.translate(this.translationSegment.translationSegmentId);
            },
            doAddTranslation() {
                if (this.showSave) {
                    this.translationSegmentService.addTranslation(this.translationSegment.translationSegmentId)
                }
            },
            doUpdateTranslation() {
                if (this.showUpdate) {
                    this.translationSegmentService.updateTranslation(this.translationSegment.translationSegmentId)
                }
            },
            doToogleVariantsPopup() {
                this.setFocus();

                this.translationSegmentService.toogleCurrentSegmentVariantsPopup();
            },
            setFocus() {
                if (this.segmentItem.focused)
                    return;

                this.segmentItem.focused = !this.segmentItem.focused;
            },
        }

    });
</script>

<style lang="scss" scoped>
    .controls {
        display: flex;
        width: 223px;
        margin-top: 7px;

        .segment-control {
            cursor: pointer;
            width: 27px;
            height: 27px;
            margin: 7px;
        }
    }
</style>